import React from 'react'
import { rem } from 'polished'
import styled, { withTheme } from 'styled-components'
import IconUser from '../../../vectors/IconUser'

const User = styled(({ theme, ...rest }) => <IconUser {...rest} />)`
  width: ${rem('27px')};
  height: ${rem('26px')};
`

export default withTheme(User)
